export const formatDateStandard = (inputDate) => {
    if (!inputDate) return "";
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return "";
    const pad = (n) => String(n).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const hasSeconds = seconds !== "00";
    return `${year}-${month}-${day} ${hours}:${minutes}${hasSeconds ? `:${seconds}` : ""}`;
};

export const formatHour = (inputDate) => {
    if (!inputDate) return "";
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return "";
    const pad = (n) => String(n).padStart(2, '0');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);
    if (compareDate.getTime() === today.getTime()) {
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        return `${hours}:${minutes}`;
    } else {
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
};

export const getSmartDateLabel = (isoString) => {
  if (!isoString) return '';

  const date = new Date(isoString);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const isSameDay = (d1, d2) =>
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getFullYear() === d2.getFullYear();

  if (isSameDay(date, today)) {
    return 'Hoy';
  }

  if (isSameDay(date, yesterday)) {
    return 'Ayer';
  }

  const daysAgo = Math.floor((today - date) / (1000 * 60 * 60 * 24));
  if (daysAgo < 7) {
    return date.toLocaleDateString('es-ES', { weekday: 'long' }); 
  }

  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};
  